<template>
  <div class="auth-shell">
    <div class="auth-card surface-elevated">
      <div class="brand-wrap">
        <img class="brand-logo" src="@/assets/images/logo.png" alt="BestPhone" />
      </div>

      <div class="stack-sm auth-header">
        <h1 class="display-title">{{ get_word('forgot_password') || 'שכחת סיסמה' }}</h1>
        <p class="muted">{{ get_word('forgot_password_subtitle') || 'מזינים כתובת מייל, ואנחנו שולחים מיד קישור לאיפוס סיסמה.' }}</p>
      </div>

      <form class="auth-form stack-md" @submit.prevent="submitForgotPassword">
        <div class="field">
          <label class="form-label">{{ get_word('email') || 'דואר אלקטרוני' }}</label>
          <input
            v-model="form.email"
            type="email"
            class="input-control"
            :placeholder="get_word('email_placeholder') || 'name@example.com'"
            required
          />
          <small v-if="errors.email" class="help-error">{{ errors.email }}</small>
        </div>

        <button type="submit" :disabled="loading" class="btn btn-primary auth-submit">
          <span v-if="!loading">{{ get_word('send_reset_link') || 'שליחת קישור לאיפוס' }}</span>
          <span v-else>{{ get_word('loading') || 'טוען...' }}</span>
        </button>

        <div v-if="generalError" class="error-inline">{{ generalError }}</div>

        <div v-if="successMessage" class="success-inline">{{ successMessage }}</div>
      </form>

      <div class="auth-footer">
        <router-link to="/login" class="footer-link">{{ get_word('back_to_login') || 'חזרה להתחברות' }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForgotPassword',
  data() {
    return {
      form: {
        email: ''
      },
      loading: false,
      errors: {},
      generalError: '',
      successMessage: ''
    }
  },
  mounted() {
    if (!this.isNull(localStorage.getItem('user_token'))) {
      this.$router.push('/')
    }
  },
  methods: {
    submitForgotPassword() {
      this.errors = {}
      this.generalError = ''
      this.successMessage = ''

      if (!this.form.email) {
        this.errors.email = this.get_word('email_required') || 'יש להזין כתובת דואר אלקטרוני'
        return
      }

      this.loading = true
      this.api({
        action: 'forgot_password',
        data: {
          email: this.form.email
        },
        method: 'post'
      }, (response) => {
        this.loading = false

        const ok = response && response.data && (response.data.status === true || response.data.status === 1 || response.data.status === '1')

        if (ok) {
          this.successMessage = this.get_word('forgot_password_mail_sent') || 'אם הכתובת קיימת במערכת, קישור לאיפוס כבר בדרך לתיבת המייל.'
          return
        }

        this.generalError = this.get_word('forgot_password_failed') || 'כרגע לא הצלחנו לשלוח את הקישור. נסו שוב בעוד רגע.'
      }, () => {
        this.loading = false
        this.generalError = this.get_word('forgot_password_failed') || 'כרגע לא הצלחנו לשלוח את הקישור. נסו שוב בעוד רגע.'
      })
    }
  }
}
</script>


